var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5693 5.07426C15.1841 4.25445 15.6964 3.12723 15.4915 2C14.4668 2.10248 13.3397 2.71733 12.6225 3.53713C12.0077 4.35693 11.4953 5.38168 11.7003 6.50891C12.8274 6.61139 13.9545 5.89406 14.5693 5.07426Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 17.0812C19.5901 18.0035 19.2827 18.5158 18.7704 19.3356C17.9507 20.4629 16.926 22 15.4915 22C14.8767 22 14.5693 21.8975 14.1594 21.6926C13.6471 21.4876 13.2372 21.2827 12.3151 21.2827C11.4953 21.2827 10.983 21.4876 10.4707 21.6926C10.0608 21.795 9.75345 22 9.13865 22C7.80659 22 6.78194 20.6678 5.85974 19.4381C3.70796 16.1589 3.50302 12.1624 4.83508 10.1129C5.75728 8.57575 7.29426 7.75594 8.72879 7.75594C9.44601 7.75594 10.0607 7.96087 10.6755 8.16581L10.6756 8.16584C11.2904 8.37079 11.7003 8.57575 12.3151 8.57575C12.8274 8.57575 13.2372 8.47327 13.7496 8.26832C14.3644 8.06337 14.9792 7.85842 15.9014 7.85842C17.2334 7.85842 18.5655 8.47327 19.4877 9.70297C16.3112 11.3426 16.8236 15.8515 20 17.0812Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.80fb86615a4bfaf4f1db54343a224328.svg";
export { ForwardRef as ReactComponent };